import { Helmet } from "react-helmet-async";
import { BodyText, Heading, Stack } from "@knowtex-ai/components";
import KnowtexLogo from "../KnowtexLogo";

export const VA_LAUNCH_REQUIRED_PATH = "/auth/va/launch";

/**
 * Shown to a VA user who reaches the app without a session: a new tab, a restored tab, or a
 * bookmark. Not a sign-out and not an account problem, so neither of those pages fits.
 */
export default function VALaunchRequired() {
  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="flex min-h-screen w-[100dvw] items-center justify-center bg-white px-6 focus:outline-none"
    >
      <Helmet>
        <title>Launch from CPRS | Knowtex</title>
      </Helmet>
      <div className="max-w-md text-center">
        <Stack gap={40}>
          <div role="img" aria-label="Knowtex" className="flex justify-center text-accent2">
            <KnowtexLogo />
          </div>
          <Stack gap={12}>
            <Heading as="h1">Launch Knowtex from CPRS</Heading>
            <BodyText>
              This tab isn&apos;t signed in to Knowtex. Close it and launch Knowtex from CPRS to
              continue.
            </BodyText>
          </Stack>
        </Stack>
      </div>
    </main>
  );
}
